import React, { useEffect, useState } from 'react';
import {
    Autocomplete,
    Card,
    CardContent,
    CardHeader,
    createFilterOptions,
    FormControl,
    Grid,
    TextField,
} from '@mui/material';

import { useApi } from '../../../../api';
import { commonSx } from '../../common-styles';

import { useAlertMessage } from '../../../providers/alert-provider';
import { useUserDay } from './user-day-provider';

export const DayFuelings: React.FC = () => {
    const alert = useAlertMessage();
    const { Api } = useApi();

    const { userFuelings, setUserFuelings, isPosting } = useUserDay();
    const [fuelings, setFuelings] = useState<Fueling[]>([]);

    useEffect(() => {
        Api.Fueling.getFuelings()
            .then(({ data }) => setFuelings(data.sort((a, b) => a.name > b.name ? 1 : -1)))
            .catch(error => alert.addMessage(error));
    }, []);

    const filter = createFilterOptions<string>();

    // Change handlers
    const onChangeFuelingName = (value: string | null, idx: number) => {
        if (userFuelings[idx].name !== value) {
            setUserFuelings(_userFueling => {
                return [..._userFueling.slice(0, idx),
                {
                    ..._userFueling[idx],
                    name: value || '',
                },
                ..._userFueling.slice(idx + 1)]
            });
        }
    }

    const onChangeFuelingWhen = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, idx: number) => {
        const { value } = event.target;

        setUserFuelings(_userFueling => {
            return [..._userFueling.slice(0, idx),
            {
                ..._userFueling[idx],
                when: value ? `0001-01-01T${value}` : null,
            },
            ..._userFueling.slice(idx + 1)]
        });
    }

    return (
        <Card sx={commonSx.card}>
            <CardHeader title="Fuelings" />
            <CardContent>
                {
                    userFuelings.map((fueling, idx) => {
                        const when = fueling.when === null ? '' : fueling.when.split('T')[1];
                        return (
                            <Grid container spacing={2} key={`fueling_${idx}`}>
                                <Grid
                                    size={{
                                        xs: 7,
                                        sm: 8,
                                        lg: 9
                                    }}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            freeSolo
                                            options={fuelings.map(fueling => fueling.name)}
                                            value={fueling.name}
                                            onInputChange={(e, v) => onChangeFuelingName(v, idx)}
                                            filterOptions={(options, params) => {
                                                params.inputValue = fueling.name;
                                                return filter(options, params);
                                            }}
                                            disabled={isPosting}
                                            renderInput={(params) => (
                                                <TextField autoComplete="off" variant="standard" {...params} name="name" />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 5,
                                        sm: 4,
                                        lg: 3
                                    }}>
                                    <FormControl fullWidth>
                                        <TextField 
                                            type="time" 
                                            name="when" 
                                            autoComplete="off" 
                                            variant="standard" 
                                            value={when} 
                                            onChange={e => onChangeFuelingWhen(e, idx)}
                                            disabled={isPosting}
                                            slotProps={{
                                                htmlInput: {
                                                    step: 300
                                                }
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        );
                    })
                }
            </CardContent>
        </Card>
    );
}
